import { useMemo, useCallback } from 'react';
import { useQuery } from '@apollo/client';
import { pssClient } from '../../constants/environment';
import { DEALERS_BY_MARKET } from '../../schemas/DealersByMarket';

export interface Dealer {
  name: string;
  region: string;
  requestServiceEn: string;
  requestServiceFr: string;
  city: string;
}

const useFetchDealersByMarket = () => {
  const { loading, data, error } = useQuery(DEALERS_BY_MARKET, {
    fetchPolicy: 'no-cache',
    client: pssClient,
    variables: {
      market: 'A-CAN',
    },
  });

  const { dealersByMarket, uniqueRegions } = useMemo(() => {
    if (!data) return { dealersByMarket: undefined, uniqueRegions: [] };

    const rawDealers = data.dealersByMarket.dealers;
    const regionsSet = new Set<string>();

    const dealers = rawDealers.map((dealer: Dealer) => {
      if (dealer.region) {
        regionsSet.add(dealer.region);
      }
      return dealer;
    });

    return {
      dealersByMarket: dealers,
      uniqueRegions: Array.from(regionsSet),
    };
  }, [data]);

  // Create the filtering function
  const getDealersByRegion = useCallback(
    (region: string) => {
      if (!dealersByMarket) return [];

      // Filter the existing dealers array by the passed region
      return dealersByMarket.filter((dealer: Dealer) => dealer.region === region) as Dealer[];
    },
    [dealersByMarket],
  );

  return { dealersByMarket, uniqueRegions, getDealersByRegion, loading, error };
};

export default useFetchDealersByMarket;
